"use client";

import { useEffect } from "react";

export default function DisableScrollRestore() {
  useEffect(() => {
    // Disable browser restoring scroll on reload/back
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // Always force top on first paint
    window.scrollTo(0, 0);
  }, []);

  return null;
}
